import type { FaireProductEntity } from "../../entity_types/product";

export const p_xdu7he3kff: FaireProductEntity = {
  token: "p_xdu7he3kff",
  type: "product",
  name: "Newborn Merino Silk Knotted Gown | Toffee",
  brandToken: "b_dntf7rsajf",
  brandName: "OAK + ACORN",
  imageUrl: "https://cdn.faire.com/fastly/8b103953179bd4636cfaf24293240cde0e7e3293b745307b1401709fdd34e302.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/dfe0594acd38c8c92242c7e8061f1f85481842b2ccf554bfffa8d61a65856565.jpeg",
    "https://cdn.faire.com/fastly/c4c6fd96973bf63043eb852fce6d6c498beb2ed76b30652bbbefe22842bf337c.jpeg"
  ],
  priceDollars: 18,
  description: "A beautifully simple essential for the earliest days. Our newborn knotted gown is made in Canada from a luxurious 70% merino wool / 30% silk blend, creating an exceptionally soft fabric that is lightweight, breathable, and naturally stretchy for a comfortable fit.\n\n\n\nMerino wool helps regulate body temperature, keeping baby warm without overheating, while silk adds an extra level of smoothness and softness against delicate newborn skin. The knit has a gentle stretch that allows baby to move comfortably while maintaining its shape.\n\n\n\nThe adjustable knotted bottom makes diaper changes quick and easy, while fold-over mitts help protect delicate skin from scratching and keep tiny hands warm without needing separate mittens.\n\n\n\nThoughtfully designed to be both practical and timeless, this gown is a beautiful first layer for sleep or everyday snuggles.\n\n\n\nFeatures\n\n\n\n * 70% merino wool / 30% silk blend \n * Lightweight, breathable, and naturally temperature regulating \n * Soft, smooth fabric with comfortable stretch \n * Adjustable knotted bottom for quick diaper changes \n * Fold-over mitts to protect baby’s skin \n * Gentle on sensitive newborn skin \n * Made in Canada \n\n\n\n\nA timeless newborn essential designed for comfort, simplicity, and natural softness.\n",
  tags: [],
  msrpDollars: 36,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:55:14.043Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
